import React from "react";
import "./Css/Gramsabha.css";

import img1 from "./Images/gram.jpg";   
import img2 from "./Images/Gram1.jpg";   
import img3 from "./Images/gram2.jpg";   
import img4 from "./Images/gram7.jpg";   
import img5 from "./Images/gram6.jpg";  


export default function GramSabhaSection() {
  return (
    <section className="gramsabha-section">
      <h2 className="gramsabha-title">ग्रामसभा</h2>

      <div className="gramsabha-layout">

        {/* LEFT BIG IMAGE */}
        <div className="item item1">
          <img src={img1} alt="" />
         
          
        </div>

        {/* TOP RIGHT - 2 IMAGES */}
        <div className="item item2">
          <img src={img2} alt="" />
        </div>

        <div className="item item3">
          <img src={img3} alt="" />
        </div>

        {/* CENTER BIG IMAGE */}
        <div className="item item4">
          <img src={img4} alt="" />
        </div>

        {/* RIGHT IMAGE */}
        <div className="item item5">
          <img src={img5} alt="" />
        </div>
      </div>
    </section>
  );
}
